<!--  -->
<template>
  <div>
    <div class="band_box">
      <div>
        <!-- <div class="choses_box">
          <div v-if="arrs.length === arr.length" @click="whole">
            取消全选
          </div>
          <div v-else @click="whole">
            全选
          </div>
        </div> -->

        <div class="serch_box">
          <el-input v-model="obr.keywords" placeholder="多个公众号搜索用 , (英文逗号)隔开" style="width:250px" />
          <el-select v-model="obr.onlyMe" placeholder="请选择" style="width:150px">
            <el-option
              v-for="item in accountarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-select v-model="obr.operation_status" placeholder="请选择" style="width:100px">
            <el-option
              v-for="item in operationarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button type="primary" class="search_icon" icon="el-icon-search" @click="secahclkick" />
        </div>
        <div class="choses_box">
          <div class="select_box" :class="[fullName?'choose_blockr':'']" @click="whole" />
          <div v-if="fullName" @click="whole">
            取消全选
          </div>
          <div v-else @click="whole">
            全选
          </div>
        </div>
        <div class="choose_allblock">
          <div v-for="item,index in arr" :key="index" :class="[item.tips?'have ':'']" class="choose_block">
            <!-- {{ item.canChecked }} -->
            <div v-if="item.canChecked === 9" class="select_boxone" />
            <div v-else class="select_box" :class="[item.tips?'choose_blockr':'']" @click="itenclick(item,index)" />
            <span>{{ item.accountName }}</span>
          </div>
        </div>

        <pagination-right
          style="padding:0px;margin-top:20px"
          :total="total"
          :page-sizes="[100]"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />

      </div>
      <div class="rigboxr">
        <div class="choiceofficialaccount">选中的公众号</div>
        <!-- <div v-for="itemr,index in arrs" :key="index" class="select_spacing" @click="rightclick(itemr.id,index)">
          {{ itemr.name }}
        </div> -->
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.id,index)"
        >
          {{ itemr.name }}
        </el-tag>
      </div>
    </div>
    <div class="que_box">
      <el-button type="primary" @click="quebtn">确定</el-button>
    </div>

  </div>
</template>

<script>
import { officialAccountlist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'

export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      obj: { // 表格参数
        page: 1,
        pageSize: 10,
        templateName: null
      },
      arr: [],
      arrs: [],
      arrsw: [],

      obr: {
        strategy_no: null,
        page: 1,
        pageSize: 100,
        keywords: null,
        account_type: 1,
        not_is_main: null,
        account_a: null,
        onlyMe: 2,
        operation_status: 1
      },
      accountarr: [{
        value: 1,
        label: '查看组内公众号'
      }, {
        value: 2,
        label: '我关联的公众号'
      }],
      operationarr: [
        {
          value: 0,
          label: '全部'
        }, {
          value: 1,
          label: '在跑'
        }, {
          value: 2,
          label: '停跑'
        }, {
          value: 3,
          label: '永封'
        }
      ],
      total: null

    }
  },
  computed: {
    fullName: function() {
      return this.arr.filter((num) => {
        return num.canChecked !== 9
      }).every(function(item) {
        return item.tips === true
      })
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

    // async nubindlist() {
    //   const data = await unbindaccountlist(this.obr)
    //   console.log(data.data.list)
    // },
    secahclkick() {
      // if (this.obr.accountName === null || this.obr.accountName === '') {
      //   this.$message.error('请输入关键字')
      //   return
      // }
      this.obr.page = 1
      this.secahclkickr()
    },
    async secahclkickr() {
      if (this.obr.keywords === '') {
        this.obr.keywords = null
      }
      console.log(this.obr)
      const data = await officialAccountlist(this.obr)
      this.total = data.data.total
      data.data.list = this.convertToHump(data.data.list)
      data.data.list.forEach((item) => {
        item.tips = false
      })
      this.arr = data.data.list
      this.arr.forEach((item) => {
        // console.log('item', item)
        this.arrs.forEach((items) => {
          if (items.id === item.appId) {
            console.log('items', item)
            item.tips = true
          }
        })
      })
    },

    // 点击确定
    async quebtn() {
      console.log('arrs', this.arrs)
      this.$emit('closedialog', this.arrs)
    },

    // 搜索回调函数
    // async searchTopicMethod(query) {
    //   console.log('q', query)
    //   if (query !== '') {
    //     this.searchTopicLoading = true // 锁住
    //     const self = this
    //     const data = await officialSearchlist({ accountName: query })
    //     if (data.code === 200) {
    //       self.topicList = data.data.list
    //     } else {
    //       self.$message({
    //         message: data.msg,
    //         type: 'error',
    //         duration: 2000, // 显示时间后自动关闭
    //         showClose: true
    //       })
    //     }
    //     /**
    //      * 搜索内容渲染到下拉框
    //      * 从 this.topicList 把数据赋值到 this.form.topic_options
    //      * 只有这样才能起作用
    //      */
    //     setTimeout(() => {
    //       this.searchTopicLoading = false
    //       this.options = this.topicList.filter(item => {
    //         return item.accountName.toLowerCase()
    //           .indexOf(query.toLowerCase()) > -1
    //       })
    //     }, 200)
    //   } else {
    //     const data = await officialSearchlist({ accountName: null })
    //     setTimeout(() => {
    //       this.searchTopicLoading = false
    //       this.options = data.data.list.filter(item => {
    //         return item.accountName.toLowerCase()
    //           .indexOf(query.toLowerCase()) > -1
    //       })
    //     }, 100)
    //   }
    // },
    itenclick(item, index) {
      item.tips = !item.tips
      if (item.tips) {
        this.arrs.push({ id: item.appId, name: item.accountName })
      } else {
        const index = this.arrs.findIndex((items) => {
          return items.id === item.appId
        })
        this.arrs.splice(index, 1)
      }
    },
    whole() {
      if (this.fullName === true) {
      // if (this.arrs.length === this.arr.length) {
        console.log('666')
        this.arr.forEach((item) => {
          if (item.canChecked === 1) {
            item.tips = false
            const index = this.arrs.findIndex((items) => {
              return items.id === item.appId
            })
            this.arrs.splice(index, 1)
          }
        })
      } else {
        console.log('777')
        this.arr.forEach((item) => {
          if (item.canChecked === 1) {
            item.tips = true
            this.arrs.map(re => re.id).includes(item.appId) || this.arrs.push({ id: item.appId, name: item.accountName })
          }
        })
        // this.arr.forEach((item) => {
        //   this.arrs.includes(item.id) || this.arr.push(item.id)
        // })
      }
    },
    rightclick(id, index) {
      console.log(id, index)
      this.arrs.splice(index, 1)
      this.arr.findIndex((items) => {
        if (items.appId === id) {
          items.tips = false
        }
      })
    },
    send(e, id, app_id_a) {
      this.id = e
      this.obr.not_is_main = id
      this.obr.account_a = app_id_a
      this.secahclkickr()
    },
    // 分页
    fetchPageSize(e) {
      this.obr.pageSize = e
      this.secahclkickr()
    },
    fetchCurrentPage(e) {
      this.obr.page = e
      this.secahclkickr()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox{
  padding: 30px;
}
.que_box{
  margin-top: 20px;
}
.have{
  color: #409eff;
}
.serch_box{
  display: flex;
  margin-bottom: 10px;
}
.search_icon{
  margin-left: 10px;
}
.band_box{
  display: flex;
}
.choses_box{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.select_boxone{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
.choose_block{
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
.choose_blockr{
  background: #409eff;
}
.rigboxr{
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}
:-webkit-scrollbar {
     width: 0 !important;
}
::-webkit-scrollbar {
     width: 0 !important;height: 0;
  }
.choiceofficialaccount{
  margin-bottom: 10px;
}
.select_spacing{
  margin-bottom: 5px;
}
.choose_allblock{
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
</style>
